import Vue from 'vue'
import Router from 'vue-router'

// Store
import store from '../store';
// Containers
import Full from '../containers/Full'

// Views
import Dashboard from '../views/Dashboard'
import Orders from '../views/Orders/Orders';
import ReadyToShip from '../views/Orders/ReadyToShip';
import Import from '../views/Orders/Import';
import Pending from '../views/Orders/Pending';
import Voided from '../views/Orders/Voided';
import Return from '../views/Orders/Return';
import SupremeFeatures from '../views/SupremeFeatures';
import AddressBook from '../views/AddressBook/Index';
import MyAccount from '../views/MyAccount/Index';
import Tutorials from '../views/Help/Tutorials';
import ContactSupport from '../views/Help/ContactSupport';
import Register from '../views/Auth/Register';
import ShowOrder from '../views/Orders/Show';
import NewShipment from '../views/Orders/NewShipment';
import ShippedOrders from '../views/Orders/Shipped';
import ShipAudit from '../views/Orders/ShipAudit';
import PendingOrders from '../views/Orders/Pending';
import CancelledOrders from '../views/Orders/Cancelled';
import Postal from '../views/Help/Postal';
import AdminUsers from '../views/Admin/Users';

import Init from '../views/Auth/Init';
import Login from '../views/Auth/Login';
import Forgot from '../views/Auth/Forgot';
import Reset from '../views/Auth/Reset';

import Upload from '../views/Orders/Import/Upload';
import ImportHistory from '../views/Orders/Import/History';

Vue.use(Router)

let router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    // Unprotected
    {
      path: '/auth',
      name: 'Auth',
      //redirect: '/auth/init',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      beforeEnter: async (to, from, next) => {
        // Check if logged in
        await store.dispatch('refreshUser')
          .then(() => { next('/orders/new-shipment'); })
          .catch((e) => {
            next();
          });
      },
      children: [
        {
          path: 'init',
          name: 'Init',
          component: Init
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register/:rep_id?',
          name: 'Register',
          component: Register
        },
        {
          path: 'usps',
          name: 'Register as USPS Rep',
          component: Register,
          props: {
            isUsps: true
          }
        },
        {
          path: 'forgot',
          name: 'Forgot Password',
          component: Forgot
        },
        {
          path: 'reset/:token',
          name: 'Reset Password',
          component: Reset
        }
      ]
    },
    // Protected routes
    {
      path: '/',
      name: 'Home',
      component: Full,
      beforeEnter: async (to, from, next) => {
        // Check if logged in
        await store.dispatch('refreshUser')
          .then(() => { next(); })
          .catch((e) => {
            next('/auth/login');
          });
      },
      children: [{
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'orders/ecommerce',
          name: 'E-commerce',
          component: ReadyToShip,
          props: {
            orderStatusId: 2,
            orderStatusName: 'ready',
          },
          children: [

          ]
        },
        {
          path: '/orders/new-shipment/:id',
          name: 'New Shipment Order',
          component: NewShipment
        },
        {
          path: '/orders/new-shipment',
          name: 'New Shipment',
          component: NewShipment,
          props: (route) => ({ addr: route.query.addr }),
        },
        {
          path: '/orders/new-shipment/user/:name',
          name: 'New Shipment User',
          component: NewShipment,
          props: true
        },
        {
          path: '/orders/shipped',
          name: 'Shipped Orders',
          component: ShippedOrders,
          props: {
            orderStatusId: 3,
            orderStatusName: 'shipped',
          }
        },
        // {
        //   path: '/orders/guarantee',
        //   name: 'Ship Audit',
        //   component: ShipAudit,
        //   props: {
        //     orderStatusId: 3,
        //     orderStatusName: 'shipped',
        //   }
        // },
        {
          path: '/orders/cancelled',
          name: 'Cancelled Orders',
          component: CancelledOrders
        },
        {
          path: '/orders/pending',
          name: 'Pending Orders',
          component: Pending,
          props: {
            key: 'pending',
            orderStatusId: 1,
            orderStatusName: 'pending'
          }
        },
        {
          path: '/orders/import',
          name: 'Import Orders',
          component: Import,
          props: {
            key: 'import',
            orderStatusId: 2,
            orderStatusName: 'import'
          }
        },
        {
          path: 'orders/upload-import',
          name: 'Upload',
          component: Upload
        },
        {
          path: 'orders/batch-label-history',
          name: 'ImportHistory',
          component: ImportHistory
        },
        {
          path: '/labels/return',
          name: 'SB Return Labels',
          component: Return,
          props: {
            orderStatusId: 5,
            orderStatusName: 'return',
          }
        },
        {
          path: '/labels/voided',
          name: 'Voided Labels',
          component: Voided,
          props: {
            orderStatusId: 4,
            orderStatusName: 'voided'
          }
        },
        // {
        //   path: '/orders/:id',
        //   name: 'orders.show',
        //   component: ShowOrder
        // },
        {
          path: 'address-book',
          name: 'Address Book',
          component: AddressBook
        },
        {
          path: 'my-account/:section?',
          name: 'My Account',
          component: MyAccount
        },
        {
          path: 'help/how-to',
          name: 'How-To Videos',
          component: Tutorials
        },
        {
          path: 'help/customer-support',
          name: 'Customer Support',
          component: ContactSupport
        },
        {
          path: 'enterprise-features',
          name: 'Enterprise Features',
          component: SupremeFeatures
        },
        {
          path: 'help/postal',
          name: 'Postal Connect',
          component: Postal
        },
        {
          path: 'admin/users',
          name: 'Users',
          component: AdminUsers
        }
      ]
    },
  ]
})

router.beforeEach((to, from, next) => {
  // ...
  //console.log('BEFORE', to, from)
  next()
});

export default router;



// WEBPACK FOOTER //
// ./resources/assets/js/router/index.js